


<script>
  export default {
    props: {
      color: {
        default: "#000",
        type: String
      },
    }
  }
</script>
<template>
    <svg viewBox="0 0 42 36" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" >
        <path :fill="color" d="M11.97 10.44C11.445 9.99004 10.57 9.99004 10.01 10.44L1.74996 17.52C1.50496 17.73 1.32996 18.03 1.32996 18.36C1.32996 18.69 1.46996 18.96 1.74996 19.2L9.90496 26.19C10.185 26.43 10.535 26.55 10.885 26.55C11.235 26.55 11.585 26.43 11.865 26.19C12.39 25.74 12.39 24.99 11.865 24.51L4.65496 18.36L11.935 12.12C12.495 11.64 12.495 10.89 11.97 10.44Z"/>
        <path :fill="color" d="M30.4499 26.16C30.7299 26.4 31.0799 26.52 31.4299 26.52C31.7799 26.52 32.1299 26.4 32.4099 26.16L40.5649 19.17C40.8099 18.96 40.9849 18.66 40.9849 18.33C40.9849 18 40.8449 17.73 40.5649 17.49L32.2699 10.44C31.7449 9.99004 30.8699 9.99004 30.3099 10.44C29.7849 10.89 29.7849 11.64 30.3099 12.12L37.5899 18.36L30.4499 24.51C29.9249 24.96 29.9249 25.71 30.4499 26.16Z"/>
        <path :fill="color" d="M16.2749 30.51C16.8349 30.51 17.3599 30.21 17.5699 29.76L27.3349 7.71002C27.6149 7.11002 27.2299 6.42002 26.5299 6.18002C25.8299 5.94002 25.0249 6.27002 24.7449 6.87002L14.9799 28.92C14.6999 29.52 15.0849 30.21 15.7849 30.45C15.9599 30.48 16.0999 30.51 16.2749 30.51Z"/>
    </svg>
</template>